__webpack_require__.p = "https://bump.sh/packs/";